<a [routerLink]="href$ | async">{{ coach?.person?.fullName }}</a>
